var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
import NoteTypeDomainService from "../Domain/NoteType/NoteType.service";
const baseURL = "/aviso/noteType";
export default class NoteTypeService {
    static searchAllActiveForPerson(personId, search, includeAlertNoteTypes, includeManualEntry) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!personId) {
                return [];
            }
            const apiClient = getApiClient();
            const response = yield apiClient.get("/noteTypes/search/searchAllActiveForPerson", {
                params: { personId, search, includeAlertNoteTypes, includeManualEntry },
            });
            return response.data._embedded.noteTypes;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/noteTypes/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.noteTypes;
        });
    }
    static getAll() {
        return FetchService.get(baseURL + "/listAsJson").then((noteTypes) => noteTypes.map(NoteTypeDomainService.fromJSON));
    }
    /**
     * Returns search results on note types limited for the current user
     * Not renaming this method or changing it for now due to usages not being fully clear
     */
    static search(query, max = 100) {
        return FetchService.get(baseURL + "/searchNoteTypes", {
            query,
            max,
        }).then((noteTypes) => noteTypes.map(NoteTypeDomainService.fromJSON));
    }
    /**
     * Returns search results on all existing note types
     */
    static searchAll({ query, active, max, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield FetchService.getPagedResponse(baseURL + "/search", {
                query,
                active,
                max,
            });
            return Object.assign(Object.assign({}, results), { data: results.data.map(NoteTypeDomainService.fromJSON) });
        });
    }
}
